import { fromJS } from 'immutable';
const action = name => `/userMST/${name}`;

export const GET_ACTIVE_INTG_LIST = action('GET_ACTIVE_INTG_LIST');
export const GET_ACTIVE_INTG_SUCCESS = action('GET_ACTIVE_INTG_SUCCESS');
export const GET_ACTIVE_INTG_LIST_ERROR = action('GET_ACTIVE_INTG_LIST_ERROR');

export const getActiveIntgList = data => ({ type: GET_ACTIVE_INTG_LIST, data });
export const getActiveIntgListSuccess = data => ({ type: GET_ACTIVE_INTG_SUCCESS, data });
export const getActiveIntgListError = data => ({ type: GET_ACTIVE_INTG_LIST_ERROR, data });


//getWidgetById
export const GET_WIDGET_BY_ID = action('GET_WIDGET_BY_ID');
export const GET_WIDGET_BY_ID_SUCCESS = action('GET_WIDGET_BY_ID_SUCCESS');

export const getWidgetById = data => ({ type: GET_WIDGET_BY_ID, data });
export const getWidgetByIdSuccess = data => ({ type: GET_WIDGET_BY_ID_SUCCESS, data });


//get icon list
export const GET_IMG_LIST = action('GET_IMG_LIST');
export const GET_IMG_LIST_SUCCESS = action('GET_IMG_LIST_SUCCESS');
export const GET_IMG_LIST_ERROR = action('GET_IMG_LIST_ERROR');

export const getIconList = data => ({ type: GET_IMG_LIST, data });
export const getIconListSuccess = data => ({ type: GET_IMG_LIST_SUCCESS, data });
export const getIconListError = data => ({ type: GET_IMG_LIST_ERROR, data });

//delete icon
export const DELETE_ICON = action('DELETE_ICON');
export const DELETE_ICON_ERROR = action('DELETE_ICON_ERROR');

export const deleteIcon = data => ({ type: DELETE_ICON, data });
export const deleteIconError = data => ({ type: DELETE_ICON_ERROR, data });


//get theme list
export const GET_WIDGET_DATA = action('GET_WALL_DATA');
export const GET_WIDGET_DATA_SUCCESS = action('GET_WALL_DATA_SUCCESS');
export const GET_WIDGET_DATA_ERROR = action('GET_WALL_DATA_ERROR');

export const getWidgetData = data => ({ type: GET_WIDGET_DATA, data });
export const getWidgetDataSuccess = data => ({ type: GET_WIDGET_DATA_SUCCESS, data });
export const getWidgetDataError = data => ({ type: GET_WIDGET_DATA_ERROR, data });

//add data source
export const ADD_DATA_SRC = action('ADD_DATA_SRC');
export const ADD_DATA_SRC_ERROR = action('ADD_DATA_SRC_ERROR');

export const addDataSrc = data => ({ type: ADD_DATA_SRC, data });
export const addDataSrcError = data => ({ type: ADD_DATA_SRC_ERROR, data });

//delete data source
export const DELETE_DATA_SRC = action('DELETE_DATA_SRC');
export const DELETE_DATA_SRC_ERROR = action('DELETE_DATA_SRC_ERROR');

export const delDataSrc = data => ({ type: DELETE_DATA_SRC, data });
export const delDataSrcError = data => ({ type: DELETE_DATA_SRC_ERROR, data });

//update wall cnf
export const UPD_WIDGET_CNF = action('UPD_WIDGET_CNF');
export const updWidgetCnf = data => ({ type: UPD_WIDGET_CNF, data });

//createWall
export const CREATE_WIDGET = action('CREATE_WIDGET');
export const createWidget = data => ({ type: CREATE_WIDGET, data });

//get widget list By User
export const GET_WIDGET_BY_USER = action('GET_WIDGET_BY_USER');
export const GET_WIDGET_BY_USER_SUCCESS = action('GET_WIDGET_BY_USER_SUCCESS');

export const getWidgetByUser = data => ({ type: GET_WIDGET_BY_USER, data });
export const getWidgetByUserSuccess = data => ({ type: GET_WIDGET_BY_USER_SUCCESS, data });

//update wall status 
export const UPD_WIDGET_STATUS = action('UPD_WIDGET_STATUS');
export const UPDATE_WIDGET_STATUS_SUCCESS = action('UPDATE_WIDGET_STATUS_SUCCESS');
export const UPDATE_WIDGET_STATUS_ERROR = action('UPDATE_WIDGET_STATUS_ERROR');

export const updWidgetStatus = data => ({ type: UPD_WIDGET_STATUS, data });
export const updWidgetStatusSuccess = data => ({ type: UPDATE_WIDGET_STATUS_SUCCESS, data });
export const updWidgetStatusError = data => ({ type: UPDATE_WIDGET_STATUS_ERROR, data });

//delete user wall
export const DEL_USER_WIDGET = action('DEL_USER_WIDGET');
export const delUserWidget = data => ({ type: DEL_USER_WIDGET, data });

export const GET_ANALYTICS = action('GET_ANALYTICS');
export const GET_ANALYTICS_SUCCESS = action('GET_ANALYTICS_SUCCESS');

export const getAnalytic = data => ({ type: GET_ANALYTICS, data });
export const getAnalyticSuccess = data => ({ type: GET_ANALYTICS_SUCCESS, data });

//hireUs
export const CREATE_HIRE_US = action('CREATE_HIRE_US');
export const createHireUs = data => ({ type: CREATE_HIRE_US, data });

//update widget name
export const UPD_WIDGET_NAME = action('UPD_WIDGET_NAME');
export const updWidgetName = data => ({ type: UPD_WIDGET_NAME, data });

//without login create widget
export const REDIS_CREATE_WIDGET = action('REDIS_CREATE_WIDGET');
export const redisCreateWidget = data => ({ type: REDIS_CREATE_WIDGET, data });


//Create clone widget
export const CREATE_CLONE_WIDGET = action('CREATE_CLONE_WIDGET');
export const CREATE_CLONE_WIDGET_ERROR = action('CREATE_CLONE_WIDGET_ERROR');

export const createCloneWidget = data => ({ type: CREATE_CLONE_WIDGET, data });
export const createCloneWidgetError = data => ({ type: CREATE_CLONE_WIDGET_ERROR, data });

//call interval function
export const INTERVAL_CALL_FUNCTION = action('INTERVAL_CALL_FUNCTION');
export const interValCall = data => ({ type: INTERVAL_CALL_FUNCTION, data });

//add widget div shopify
export const ADD_SHP_WIDGET_DIV = action('ADD_SHP_WIDGET_DIV');
export const ADD_SHP_WIDGET_DIV_SUCCESS = action('ADD_SHP_WIDGET_DIV_SUCCESS');

export const addShpWidgetDiv = data => ({ type: ADD_SHP_WIDGET_DIV, data });
export const addShpWidgetDivSuccess = data => ({ type: ADD_SHP_WIDGET_DIV_SUCCESS, data });

export const GET_SHP_THEME_LIST = action('GET_SHP_THEME_LIST');
export const getShpThemeList = data => ({ type: GET_SHP_THEME_LIST, data });

export const DELETE_SHP_WIDGET_DIV = action('DELETE_SHP_WIDGET_DIV');
export const deleteShpWidgetDiv = data => ({ type: DELETE_SHP_WIDGET_DIV, data });

//update widget Icon
export const UPD_WIDGET_ICON = action('UPD_WIDGET_ICON');
export const updWidgetIcon = data => ({ type: UPD_WIDGET_ICON, data });

//onchange update widget
export const ON_CHANGE_UPD_WIDGET = action('ON_CHANGE_UPD_WIDGET');
export const onChangeUpdateWidget = data => ({ type: ON_CHANGE_UPD_WIDGET, data });

// onChange save filter function
export const ON_CHANGE_SAVE_FILTER = action('ON_CHANGE_SAVE_FILTER');
export const ON_CHANGE_SAVE_FILTER_SUCCESS = action('ON_CHANGE_SAVE_FILTER_SUCCESS');

export const onChangeSaveFilter = data => ({ type: ON_CHANGE_SAVE_FILTER, data });
export const onChangeSaveFilterSuccess = data => ({ type: ON_CHANGE_SAVE_FILTER_SUCCESS, data });

// onChange save filter function
export const UPD_SCHEMA_VALUE = action('UPD_SCHEMA_VALUE');
export const UPD_SCHEMA_VALUE_SUCCESS = action('UPD_SCHEMA_VALUE_SUCCESS');

export const updSchemaValue = data => ({ type: UPD_SCHEMA_VALUE, data });
export const updSchemaValueSuccess = data => ({ type: UPD_SCHEMA_VALUE_SUCCESS, data });

const initialState = fromJS({

});

const widget = (state = initialState, action) => {
  switch (action.type) {
    case GET_WIDGET_BY_ID_SUCCESS:
      return state.set('widgetById', action.data);

    //get Active Intg. List
    case ON_CHANGE_SAVE_FILTER_SUCCESS:
      return state.set('filterSave', action.data);

    //get Active Intg. List
    case UPD_SCHEMA_VALUE_SUCCESS:
      return state.set('schemaValue', action.data);

    //get Active Intg. List
    case GET_ACTIVE_INTG_SUCCESS:
      return state.set('lstActiveIntg', action.data);

    //update Notification status
    case UPDATE_WIDGET_STATUS_SUCCESS:
      return state.set('activeStatus', action.data);
    case UPDATE_WIDGET_STATUS_ERROR:
      return state = action.data;

    case GET_WIDGET_DATA_SUCCESS:
      return state.set('lstWidgetData', action.data);

    //get the widget list by user
    case GET_WIDGET_BY_USER_SUCCESS:
      return state.set('userWidget', action.data);

    //get widget analytics
    case GET_ANALYTICS_SUCCESS:
      return state.set('analytic', action.data);

    case ADD_SHP_WIDGET_DIV_SUCCESS:
      return state.set('lstWidgetDiv', action.data);

    //get icon list
    case GET_IMG_LIST_SUCCESS:
      return state.set('iconList', action.data);
    default:
      return state;
  }
};

export default widget;


// WEBPACK FOOTER //
// ./src/ducks/widget.js